import React from 'react'

const Playing = ({
    title = 'Сейчас играет',
    className = '',
    size,
    variant,
    onClick
}) => {
    return (
        <i
            className={`${className} spp-svg ${variant ? 'spp-svg-color-' + variant : ''} ${size ? 'spp-svg-size-' + size : ''}`}
            onClick={onClick}
        >
            <svg viewBox="0 0 24 24" width="1.5em" height="1.5em">
                <title>{title}</title>

                <rect className="bar bar1" x="3" y="10" width="3" height="8" rx="1" />
                <rect className="bar bar2" x="9" y="6" width="3" height="12" rx="1" />
                <rect className="bar bar3" x="15" y="12" width="3" height="6" rx="1" />
            </svg>
        </i>
    )
}

export default Playing